import { FC } from "react"

interface NoResultsMessageProps {
   titleTerm: string
   searchTerm?: string
}

export const NoResultsMessage: FC<NoResultsMessageProps> = ({
   titleTerm,
   searchTerm,
}) => (
   <div className="search-and-select__no-results">
      {searchTerm ? (
         <>
            <div>{`No ${titleTerm} found matching "${searchTerm}"`}</div>
            <div>Please try a different search term</div>
         </>
      ) : (
         <div>{`No ${titleTerm} available`}</div>
      )}
   </div>
)
